import {
  ColumnSetting,
  ColumnsOrderState,
  ColumnsVisibilityState,
  ColumnsWidthState,
  InvoiceData,
} from '../../dashboard/components/InvoiceSettings/types';

export interface InvoiceSettingsStoreState {
  data: InvoiceData | null;
  isLoading: boolean;
  isSaving: boolean;
  isReadOnly: boolean;
  isEditMode: boolean;
  error: string | null;
  invoiceId: string | null;
  vendorId: string | null;
  categoryIndex: number;
  tableWidth: number | null;
  columnsVisibilityState: ColumnsVisibilityState | null;
  columnsWidthState: ColumnsWidthState | null;
  columnsOrderState: ColumnsOrderState | null;
  columnsState: ColumnSetting[];
  defaultColumnsSettings: ColumnSetting[] | null;
  tableRenderKey: number;
}

const invoiceSettingsState: InvoiceSettingsStoreState = {
  data: null,
  isLoading: false,
  isSaving: false,
  isReadOnly: false,
  isEditMode: false,
  error: null,
  invoiceId: null,
  vendorId: null,
  categoryIndex: 0,
  tableWidth: null,
  columnsVisibilityState: null,
  columnsWidthState: null,
  columnsOrderState: null,
  columnsState: [],
  defaultColumnsSettings: null,
  tableRenderKey: 0,
};

export default invoiceSettingsState;
